import React from 'react';
import { Formik } from 'formik';
import Page from '../components/Page';
import * as Yup from 'yup';
import { FormattedMessage, injectIntl } from 'react-intl';

const ContatoSchema = Yup.object().shape({
   nome: Yup.string()
     .required(<FormattedMessage id="contato.placeholder1"/>),
   mensagem: Yup.string()
     .required(<FormattedMessage id="contato.placeholder3"/>),
   email: Yup.string()
     .email(<FormattedMessage id="contato.invalid_email"/>)
     .required(<FormattedMessage id="contato.placeholder2"/>),
});

const Contato = (props) => {

   const intl = props.intl;

   const placeholder1 = intl.formatMessage({
      id: "contato.placeholder1"
   });
   const placeholder2 = intl.formatMessage({
      id: "contato.placeholder2"
   });
   const placeholder3 = intl.formatMessage({
      id: "contato.placeholder3"
   });

   function submitForm(values, actions) {
      setTimeout(() => {
         actions.setSubmitting(false);
      }, 400);
   }
   
   return(
      <Page view="contato" bg="/assets/img/contato-bg.jpg">
         <h1><FormattedMessage id="contato.h1"/></h1>
         
         <div className="row">
            <div className="form-details col-md-5">
               <p><FormattedMessage id="contato.p1"/></p>
               <p><FormattedMessage id="contato.p2"/></p>
               <p><FormattedMessage id="contato.p3"/></p>
               <p><strong><FormattedMessage id="contato.p4" values={{
                  a: msg => (
                     <a className="link" href="mailto:covidfront@gmail.com">{msg}</a>
                  )
               }}/></strong></p>
            </div>
            <div className="col-md-7">
               <Formik
                  
                  initialValues={{ 
                     nome: '', 
                     email: '', 
                     mensagem: '' 
                  }}

                  validationSchema={ContatoSchema}

                  onSubmit={(values, { setSubmitting }) => submitForm(values, { setSubmitting })}
               >
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     handleSubmit,
                     isSubmitting,
                  }) => (
                     <form className="form" onSubmit={handleSubmit}>
                        <div className="row">
                           <div className="col-md-6">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="nome"><FormattedMessage id="contato.label1"/><span className="form-required">*</span></label>
                                 <input
                                    className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                                    type="text"
                                    name="nome"
                                    placeholder={placeholder1}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.nome}
                                 />
                                 {errors.nome && touched.nome ? ( <span className="form-error"> {errors.nome} </span> ) : null}
                              </div>
                           </div>
                           <div className="col-md-6">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="email"><FormattedMessage id="contato.label2"/><span className="form-required">*</span></label>
                                 <input
                                    className={`form-input ${ errors.email && touched.email ? 'is-invalid' : '' }`}
                                    placeholder={placeholder2}
                                    type="email"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                 />
                                 {errors.email && touched.email ? ( <span className="form-error"> {errors.email} </span> ) : null}
                              </div>
                           </div>
                           <div className="col-md-12">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="nome"><FormattedMessage id="contato.label3"/><span className="form-required">*</span></label>
                                 <textarea
                                    className={`form-input ${ errors.mensagem && touched.mensagem ? 'is-invalid' : '' }`}
                                    placeholder={placeholder3}
                                    type="text"
                                    name="mensagem"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.messagem}
                                 ></textarea>
                                 {errors.mensagem && touched.mensagem ? ( <span className="form-error"> {errors.mensagem} </span> ) : null}
                              </div>
                           </div>
                        </div>
                        <button className="button button--primary" type="submit" disabled={isSubmitting}><FormattedMessage id="contato.submit"/></button>
                     </form>
                  )}
               </Formik>
            </div>
         </div>
      </Page>
   )
}

export default injectIntl(Contato);
